/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class RenderSequenceAPI
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class RenderSequenceAPI {

		/**
		 * payload passed to callbacks
		 * @typedef {Object} TaskExecutionInfo
		 * @property {string} taskId - id of the executed task
		 * @property {RenderContextAPI} renderContent - renderContext API
		 * @property {Object} error - error of the task execution
		 */

		/**
		 * @public
		 * @function RenderSequenceAPI#onStartTaskExecution
		 * @description registers the callback when task starts; callback will be called with {@link TaskExecutionInfo} as parameter
		 * @param {function} callback - method to register
		 */
		onStartTaskExecution() {}

		/**
		 * @public
		 * @function RenderSequenceAPI#onResolveTaskExecution
		 * @description registers the callback when task ends successfully; allback will be called with {@link TaskExecutionInfo} as parameter
		 * @param {function} callback - method to register
		 */
		onResolveTaskExecution() {}

		/**
		 * @public
		 * @function RenderSequenceAPI#onRejectTaskExecution
		 * @description registers the callback when task end with failure; allback will be called with {@link TaskExecutionInfo} as parameter
		 * @param {function} callback - method to register
		 */
		onRejectTaskExecution() {}

		/**
		 * @public
		 * @function RenderSequenceAPI#registerRenderStepProvider
		 * @description Registers a render step provider. A render step provider can add custom render steps that will be executed when the visualization is rendered
		 * @param {RenderStepProviderAPI} provider - render step provider
		 */
		registerRenderStepProvider() {}
	}

	return RenderSequenceAPI;
});